exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#page {\r\n    height: 85vh;\r\n    overflow-y:auto;\r\n}\r\n@media screen and (max-width: 767px) {\r\n   #page{\r\n       padding-bottom:70px;\r\n   }\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n   #page{\r\n       padding-bottom:35px;\r\n   }\r\n}\r\n\r\n\r\n\r\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./Content/css/page.css
 ** module id = 940
 ** module chunks = 2
 **/